import React, { useState } from "react";
import Section from "@/components/footer/Ifooter";

const MobileScreen = ({ topSection }): JSX.Element => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordian = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <>
      <ul className="mobileScreen">
        {topSection &&
          topSection.map((section: Section, index: number) => (
            <li className="col-md-12  link-category" key={index}>
              <button
                aria-controls="footer_accordion_section_1"
                id="footer_accordion_1_id"
                onClick={() => toggleAccordian(index)}
              >
                <span
                  className={`${
                    activeIndex === index ? "category_title" : "null"
                  }`}
                >
                  {section.heading.replace(/~/g,'')}{" "}
                </span>
                <span
                  className={`icon arrow-style ${
                    activeIndex === index ? "arrow-up" : "arrow-down"
                  }`}
                ></span>
              </button>
              {activeIndex === index && (
                <div
                  id="footer_accordion_section_1"
                  role="region"
                  aria-labelledby="footer_accordion_1_id"
                >
                  <ul>
                    {section.data.map((links, subIndex) => (
                      <li key={subIndex}>
                        <a
                          href={links['disable']?undefined:links["href"]}
                          target={links['target']}
                          rel="noreferrer"
                          className={`${
                            links["disable"] ? "list-default-color disableAnchorLink" : "list-name"
                          } ext-icon`}
                        >
                          {links["label"].replace(/~/g,'')}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </li>
          ))}
      </ul>
    </>
  );
};

export default MobileScreen;
